import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import CryptoJS from "crypto-js";

import Box from "@mui/material/Box";
import MuiCard from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import FormLabel from "@mui/material/FormLabel";
import { OutlinedInput, FormControl, FormHelperText } from "@mui/material";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
//
import "dayjs/locale/es-mx";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
//
import ContactMailIcon from "@mui/icons-material/ContactMail";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import FolderSharedIcon from "@mui/icons-material/FolderShared";

import { useAuth } from "../../Auth/AuthProtecter";
import useGetCombSelect from "../../../hooks/Consultas/useGetCombSelect";
import AutocompleteCom from "../../../Componentes/Kit/AutoComplete/AutocompleteCom";

const LST = process.env.REACT_APP_API_FRRS_LSTOREGE;
const secretKey = process.env.REACT_APP_SECRET_KEY_LOCALSTORAGE;

const Card = styled(MuiCard)(({ theme }) => ({
  border: "1px solid",
  borderColor: (theme.vars || theme).palette.divider,
  width: "100%",
  "&:hover": {
    background:
      "linear-gradient(to bottom right, hsla(210, 100%, 97%, 0.5) 25%, hsla(210, 100%, 90%, 0.3) 100%)",
    borderColor: "primary.light",
    boxShadow: "0px 2px 8px hsla(0, 0%, 0%, 0.1)",
    ...theme.applyStyles("dark", {
      background:
        "linear-gradient(to right bottom, hsla(210, 100%, 12%, 0.2) 25%, hsla(210, 100%, 16%, 0.2) 100%)",
      borderColor: "primary.dark",
      boxShadow: "0px 1px 8px hsla(210, 100%, 25%, 0.5) ",
    }),
  },
  [theme.breakpoints.up("md")]: {
    flexGrow: 1,
    maxWidth: `calc(100% - ${theme.spacing(1)})`,
    // maxWidth: `calc(50% - ${theme.spacing(1)})`,
  },
  variants: [
    {
      props: ({ selected }) => selected,
      style: {
        borderColor: (theme.vars || theme).palette.primary.light,
        ...theme.applyStyles("dark", {
          borderColor: (theme.vars || theme).palette.primary.dark,
        }),
      },
    },
  ],
}));

const PaymentContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  width: "100%",
  height: "auto",
  padding: theme.spacing(2),
  borderRadius: `calc(${theme.shape.borderRadius}px + 4px)`,
  border: "1px solid ",
  borderColor: (theme.vars || theme).palette.divider,
  background:
    "linear-gradient(to bottom right, hsla(220, 35%, 97%, 0.3) 25%, hsla(220, 20%, 88%, 0.3) 100%)",
  boxShadow: "0px 4px 8px hsla(210, 0%, 0%, 0.05)",
  [theme.breakpoints.up("xs")]: {
    height: "auto",
    //height: 300,
  },
  [theme.breakpoints.up("sm")]: {
    // height: 350,
    height: "auto",
  },
  ...theme.applyStyles("dark", {
    background:
      "linear-gradient(to right bottom, hsla(220, 30%, 6%, 0.2) 25%, hsla(220, 20%, 25%, 0.2) 100%)",
    boxShadow: "0px 4px 8px hsl(220, 35%, 0%)",
  }),
}));

const FormGrid = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));


export default function AddressFormOne({ ...other }) {

  const auth = useAuth();
  const [Url, setLoginUrl] = React.useState(auth.Domain);


  const bytes = CryptoJS.AES.decrypt(sessionStorage.getItem(LST), secretKey);
  const dataperson = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

  // const email = auth.infoUserCheck().email;
  const person = auth.infoUserCheck().person;

  // const Url = process.env.REACT_APP_URL;
  const UrlCililState = process.env.REACT_APP_CIVILSTATE;
  const UrlCountry = process.env.REACT_APP_COUNTRY;
  const UrlNationality = process.env.REACT_APP_NATIONALITY;
  const UrlGender = process.env.REACT_APP_GENDER;

  const optNationality = useGetCombSelect(Url, UrlNationality);
  const optCountry = useGetCombSelect(Url, UrlCountry);
  const optGender = useGetCombSelect(Url, UrlGender);
  const optCivilState = useGetCombSelect(Url, UrlCililState);

  const sfalse = false;
  const [valuebirthdate, setValue] = React.useState("");
  const fechaActual = new Date();
  const dia = fechaActual.getDate();
  const mes = fechaActual.getMonth() + 1; // Los meses en JavaScript van de 0 a 11, por lo que añadimos 1
  const año = fechaActual.getFullYear();
  const fechaFormateada = `${mes}-${dia}-${año}`;

  //Boton
  const [ActiveButtom, setActiveButtom] = React.useState(false);

  // FORMU
  const [firstname, setFirstName] = React.useState("");
  const [Firstname, setFirstname] = React.useState("");
  //
  const [middlename, setMiddleName] = React.useState("");
  const [Middlename, setMiddlename] = React.useState("");
  //
  const [lastname, setLastName] = React.useState("");
  const [Lastname, setLastname] = React.useState("");
  //
  const [secondlastname, setSecondLastName] = React.useState("");
  const [Secondlastname, setSecondlastname] = React.useState("");
  //
  const [birthplace, setBirthPlace] = React.useState("");
  const [Birthplace, setBirthplace] = React.useState("");
  //
  const [civilstate, setCivilstate] = React.useState("");
  const [civilState, setCivilState] = React.useState("");
  //
  const [genderId, setGenderId] = React.useState("");
  //
  const [CountryBirthID, setCountryBirthID] = React.useState("");
  //
  const [nationality, setNationalityId] = React.useState("");
  const [NationalidadID, setNationalidadID] = React.useState("");
  //
  const [birthdate, setBirthDate] = React.useState("");
  //
  const [idparty, setIdparty] = React.useState("");
  //
  const [personid, setPersonId] = React.useState("");
  //
  const [countrybirth, setCountryBirth] = React.useState("");
  //
  const [gender, setGender] = React.useState("");

  // Error Form
  // Error Form
  const [firstnameError, setfirstnameError] = React.useState(false);
  const [firstnameErrorMessage, setFirstNameErrorMessage] = React.useState("");

  const [middlenameError, setmiddlenameError] = React.useState(false);
  const [middlenameErrorMessage, setmiddlenameErrorMessage] =
    React.useState("");

  const [lastnameError, setlastnameError] = React.useState(false);
  const [lastnameErrorMessage, setlastnameErrorMessage] = React.useState("");

  const [secondlastnameError, setsecondlastnameError] = React.useState(false);
  const [secondlastnameErrorMessage, setsecondlastnameErrorMessage] =
    React.useState("");

  const [datebirthdate, setDateBirthdate] = React.useState(null);
  const [birthdateError, setBirthdateError] = React.useState(false);
  const [birthdateErrorMessage, setBirthdateErrorMessage] = React.useState("");

  const [birthplaceError, setbirthplaceError] = React.useState(false);
  const [birthplaceErrorMessage, setbirthplaceErrorMessage] =
    React.useState("");

  const [civilstateError, setcivilstateError] = React.useState(false);
  const [civilstateErrorMessage, setcivilstateErrorMessage] =
    React.useState("");

  const [genderError, setgenderError] = React.useState(false);
  const [genderErrorMessage, setgenderErrorMessage] = React.useState("");

  const [nationalityError, setnationalityError] = React.useState(false);
  const [nationalityErrorMessage, setnationalityErrorMessage] =
    React.useState("");

  const [countrybirthError, setcountrybirthError] = React.useState(false);
  const [countrybirthErrorMessage, setcountrybirthErrorMessage] =
    React.useState("");

  const FirstnameHandleChange = (event) => {
    const upperCaseValue = event.target.value.toUpperCase();
    setFirstname(upperCaseValue);
  };
  const MiddlenameHandleChange = (event) => {
    const upperCaseValue = event.target.value.toUpperCase();
    setMiddlename(upperCaseValue);
  };
  const LastnameHandleChange = (event) => {
    const upperCaseValue = event.target.value.toUpperCase();
    setLastname(upperCaseValue);
  };
  const SecondlastnameHandleChange = (event) => {
    const upperCaseValue = event.target.value.toUpperCase();
    setSecondlastname(upperCaseValue);
  };
  const BirthplaceHandleChange = (event) => {
    const upperCaseValue = event.target.value.toUpperCase();
    setBirthplace(upperCaseValue);
  };

  window.setTimeout(() => {
    if (person === "~") {
      setFirstName("~");
      setMiddleName("~");
      setLastName("~");
      setSecondLastName("~");
      setBirthPlace("~");
      setCivilstate("~");
      setGenderId("~");
      setNationalityId("~");
      setBirthDate("~");
      setPersonId("~");
      setIdparty("~");
      setCountryBirth("~");
      setGender("~");
    } else {
      const {
        birthdate,
        birthplace,
        civilstate,
        countrybirth,
        firstname,
        gender,
        idparty,
        lastname,
        middlename,
        nationality,
        personid,
        secondlastname,
      } = person;

      setFirstName(firstname);
      setMiddleName(middlename);
      setLastName(lastname);
      setSecondLastName(secondlastname);
      setBirthPlace(birthplace);
      setNationalityId(nationality);
      setBirthDate(birthdate);
      setPersonId(idparty);
      setIdparty(personid);
      setCountryBirth(countrybirth);
      setGender(gender);
      setCivilstate(civilstate);
    }
  }, 1);

  useEffect(() => {
    if (birthdate === "~") {
      setDateBirthdate(convertirFecha(valuebirthdate));
    }
  }, [valuebirthdate, birthdate]);

  const validateInputs = (e) => {
    //
    let isValid = true;
    //
    const nameValid = /^[A-Za-zÁÉÍÓÚáéíóúñÑ\s'-]+$/;
    //
    const firstname = document.getElementById("firstname");
    const middlename = document.getElementById("middlename");
    const lastname = document.getElementById("lastname");
    const secondlastname = document.getElementById("secondlastname");
    const birthplace = document.getElementById("birthplace");
    //
    // ########### civilstate
    const civilstateGet = document.getElementById("civilstate");
    const CivilStateID = optCivilState.find(
      (opcion) =>
        opcion.name.toLowerCase() === civilstateGet.value.toLowerCase()
    );

    console.log(optNationality);
    // ########### nationality
    const nationalityGet = document.getElementById("nationality");
    const NationalityID = optNationality.find(
      (opcion) =>
        opcion.name.toLowerCase() === nationalityGet.value.toLowerCase()
    );

    // ########### countrybirth
    const countrybirthGet = document.getElementById("countrybirth");
    const CountrybirthID = optCountry.find(
      (opcion) =>
        opcion.name.toLowerCase() === countrybirthGet.value.toLowerCase()
    );

    // ########### gender
    const genderGet = document.getElementById("gender");
    const GenderID = optGender.find(
      (opcion) => opcion.name.toLowerCase() === genderGet.value.toLowerCase()
    );

    const birthdateGet = document.getElementById("birthdate");

    if (birthdateGet) {
      setDateBirthdate(birthdateGet.value);
    }

    if (birthdate === "~") {
      // #############  birthdate
      if (valuebirthdate) {
        //
        if (birthdate) {
          setDateBirthdate(birthdate.value);
        } else {
          setDateBirthdate(
            valuebirthdate !== ""
              ? convertirFecha(valuebirthdate)
              : birthdate.value
          );
        }
        //
      }

      if (!valuebirthdate) {
        //
        if (!birthdate.value) {
          setBirthdateError(true);
          setBirthdateErrorMessage("Ingrese la fecha");
          isValid = false;
          console.log("F***** ", valuebirthdate);
        }
        console.log("FECHAAAAAA: ", valuebirthdate);
        //
      } else {
        //
        setBirthdateError(false);
        setBirthdateErrorMessage("");
        //
      }
    }

    if (gender === "~") {
      if (!genderId) {
        console.log("65fd59!!!!");
        setgenderError(true);
        setgenderErrorMessage("Defina este campo");
        isValid = false;
      } else {
        setgenderError(false);
        setgenderErrorMessage("");
      }
    }
    //

    if (countrybirth === "~") {
      if (!CountryBirthID) {
        console.log(CountryBirthID, "6v9v*/f*/b/fgd");

        setcountrybirthError(true);
        setcountrybirthErrorMessage("Defina este campo");
        isValid = false;
      } else {
        setcountrybirthError(false);
        setcountrybirthErrorMessage("");
      }
    }
    //
    if (nationality === "~") {
      if (!NationalidadID) {
        console.log("65vc5***");
        setnationalityError(true);
        setnationalityErrorMessage("Defina este campo");
        isValid = false;
      } else {
        setnationalityError(false);
        setnationalityErrorMessage("");
      }
    }
    //

    if (civilstate === "~") {
      if (!civilState) {
        console.log("45v5v/f//");

        setcivilstateError(true);
        setcivilstateErrorMessage("Defina este campo");
        isValid = false;
      } else {
        setcivilstateError(false);
        setcivilstateErrorMessage("");
      }
    }

    //
    if (!firstname.value || !nameValid.test(firstname.value)) {
      console.log("vbc5v55f");

      if (!firstname.value) {
        setfirstnameError(true);
        setFirstNameErrorMessage("Vacio");
      } else {
        setFirstNameErrorMessage("Sin caracteres especiales");
        setfirstnameError(true);
      }

      isValid = false;
    } else {
      setfirstnameError(false);
      setFirstNameErrorMessage("");
    }
    //
    if (!lastname.value || !nameValid.test(lastname.value)) {
      console.log("546*fdfgcg");

      if (!lastname.value) {
        setlastnameError(true);
        setlastnameErrorMessage("Vacio");
      } else {
        setlastnameError(true);
        setlastnameErrorMessage("Sin caracteres especiales");
      }

      isValid = false;
    } else {
      setlastnameError(false);
      setlastnameErrorMessage("");
    }
    //
    if (middlename.value && !nameValid.test(middlename.value)) {
      console.log("cdd6565f");

      setmiddlenameError(true);
      setmiddlenameErrorMessage("No puede contener caracteres especiales");
      isValid = false;
    } else {
      setmiddlenameError(false);
      setmiddlenameErrorMessage("");
    }
    //
    if (secondlastname.value && !nameValid.test(secondlastname.value)) {
      console.log("595656f");

      setsecondlastnameError(true);
      setsecondlastnameErrorMessage("No puede contener caracteres especiales");
      isValid = false;
    } else {
      setsecondlastnameError(false);
      setsecondlastnameErrorMessage("");
    }
    //
    if (!birthplace.value) {
      console.log("dfsdeeee");

      setbirthplaceError(true);
      setbirthplaceErrorMessage("Escriba una dirección");
      isValid = false;
    } else {
      setbirthplaceError(false);
      setbirthplaceErrorMessage("");
    }

    if (isValid) {
      const bytes = CryptoJS.AES.decrypt(
        sessionStorage.getItem(LST),
        secretKey
      );
      const array = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      const dataPost = {
        ...array,
        personid: personid,
        birthdate: birthdate === "~" ? datebirthdate : birthdateGet.value,
        birthplace: birthplace.value,
        idcivilstate: civilstate === "~" ? civilState : CivilStateID.id,
        idcountrybirth:
          countrybirth === "~" ? CountryBirthID : CountrybirthID.id,
        firstname: firstname.value,
        idgender: gender === "~" ? genderId : GenderID.id,
        idparty: idparty,
        lastname: lastname.value,
        middlename: middlename.value,
        idcountrynationality:
          nationality === "~" ? NationalidadID : NationalityID.id,
        secondlastname: secondlastname.value,
      };

      sessionStorage.setItem(
        LST,
        CryptoJS.AES.encrypt(JSON.stringify(dataPost), secretKey).toString()
      );

      other.SetActiButtom(isValid);
      setActiveButtom(true);
    } else {
      const dataPost = {
        personid: personid,
        birthdate: birthdate === "~" ? datebirthdate : birthdateGet.value,
        birthplace: birthplace.value,
        idcivilstate: civilstate === "~" ? civilState : CivilStateID.id,
        idcountrybirth:
          countrybirth === "~" ? CountryBirthID : CountrybirthID.id,
        firstname: firstname.value,
        idgender: gender === "~" ? genderId : GenderID.id,
        idparty: idparty,
        lastname: lastname.value,
        middlename: middlename.value,
        idcountrynationality:
          nationality === "~" ? NationalidadID : NationalityID.id,
        secondlastname: secondlastname.value,
      };
      console.log("erro***************", dataPost);
    }
  };

  const convertirFecha = (obj) => {
    const año = obj.$y;
    const mes = obj.$M + 1; // Añadir 1 ya que los meses en JavaScript van de 0 a 11
    const día = obj.$D; // Formatear el mes y el día para que tengan dos dígitos
    const mesFormateado = mes < 10 ? `0${mes}` : mes;
    const díaFormateado = día < 10 ? `0${día}` : día;
    return `${año}-${mesFormateado}-${díaFormateado}`;
  };
  return (
    <Stack spacing={{ xs: 1, sm: 2 }} useFlexGap>
      <FormControl component="fieldset" fullWidth>
        <Card>
          <CardActionArea
            sx={{
              ".MuiCardActionArea-focusHighlight": {
                backgroundColor: "transparent",
              },
              "&:focus-visible": {
                backgroundColor: "action.hover",
              },
            }}
          >
            <CardContent sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <ContactMailIcon
                fontSize="large"
                sx={[
                  (theme) => ({
                    color: "grey.400",
                    ...theme.applyStyles("dark", {
                      color: "grey.600",
                    }),
                  }),
                ]}
              />

              <Typography sx={{ fontWeight: "medium" }}>
                {dataperson.email}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </FormControl>
      <Alert variant="filled" severity={"warning"}>
        <AlertTitle>
          {
            "Actualmente es posible  actualizar los datos faltantes en su registro. Para cambios y correcciones, recomendamos visitar la sucursal más cercana."
          }
        </AlertTitle>
      </Alert>
      <>
        <Box
          component="form"
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <PaymentContainer>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="subtitle2">Datos personales</Typography>
              <ManageAccountsIcon sx={{ color: "text.secondary" }} />
            </Box>
            <FolderSharedIcon
              sx={{
                fontSize: { xs: 48, sm: 56 },
                // transform: "rotate(90deg)",
                color: "text.secondary",
              }}
            />
            <Box sx={{ display: "flex", gap: 2 }}>
              <FormGrid sx={{ flexGrow: 1 }}>
                <FormControl
                  error={firstnameError}
                  variant="outlined"
                  fullWidth
                >
                  <FormLabel htmlFor="firstname" required>
                    Primer nombre
                  </FormLabel>
                  <OutlinedInput
                    error={firstnameError}
                    id="firstname"
                    autoComplete="firstname"
                    placeholder="Nombre #1"
                    required
                    size="small"
                    value={firstname !== "~" ? firstname : Firstname}
                    onChange={FirstnameHandleChange}
                    disabled={firstname !== "~" || ActiveButtom ? true : sfalse}
                  />
                  {firstnameError && (
                    <FormHelperText>{firstnameErrorMessage}</FormHelperText>
                  )}
                </FormControl>
              </FormGrid>
              <FormGrid sx={{ flexGrow: 1 }}>
                <FormControl
                  error={middlenameError}
                  variant="outlined"
                  fullWidth
                >
                  <FormLabel htmlFor="middlename">Segundo nombre</FormLabel>
                  <OutlinedInput
                    id="middlename"
                    autoComplete="middlename"
                    placeholder="Nombre #2"
                    required
                    size="small"
                    value={middlename !== "~" ? middlename : Middlename}
                    onChange={MiddlenameHandleChange}
                    disabled={
                      middlename !== "~" || ActiveButtom ? true : sfalse
                    }
                  />
                  {middlenameError && (
                    <FormHelperText>{middlenameErrorMessage}</FormHelperText>
                  )}
                </FormControl>
              </FormGrid>
            </Box>

            <Box sx={{ display: "flex", gap: 2 }}>
              <FormGrid sx={{ flexGrow: 1 }}>
                <FormControl error={lastnameError} variant="outlined" fullWidth>
                  <FormLabel htmlFor="lastname" required>
                    Primer apellido
                  </FormLabel>
                  <OutlinedInput
                    id="lastname"
                    autoComplete="lastname"
                    placeholder="Apellido #1"
                    required
                    size="small"
                    value={lastname !== "~" ? lastname : Lastname}
                    onChange={LastnameHandleChange}
                    disabled={lastname !== "~" || ActiveButtom ? true : sfalse}
                  />
                  {lastnameError && (
                    <FormHelperText>{lastnameErrorMessage}</FormHelperText>
                  )}
                </FormControl>
              </FormGrid>

              <FormGrid sx={{ flexGrow: 1 }}>
                <FormControl
                  error={secondlastnameError}
                  variant="outlined"
                  fullWidth
                >
                  <FormLabel htmlFor="secondlastname">
                    Segundo apellido
                  </FormLabel>
                  <OutlinedInput
                    id="secondlastname"
                    autoComplete="secondlastname"
                    placeholder="Apellido #2"
                    size="small"
                    value={
                      secondlastname !== "~" ? secondlastname : Secondlastname
                    }
                    onChange={SecondlastnameHandleChange}
                    disabled={
                      secondlastname !== "~" || ActiveButtom ? true : sfalse
                    }
                  />
                  {secondlastnameError && (
                    <FormHelperText>
                      {secondlastnameErrorMessage}
                    </FormHelperText>
                  )}
                </FormControl>
              </FormGrid>
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <FormGrid sx={{ flexGrow: 1 }}>
                {nationality === "~" ? (
                  <AutocompleteCom
                    FormLabel={"Nacionalidad"}
                    error={nationalityError}
                    errorMessage={nationalityErrorMessage}
                    size="small"
                    placeholder={"Favorites"}
                    id={"nationality"}
                    autoComplete="nationality"
                    options={optNationality}
                    setDataId={setNationalidadID}
                    label={""}
                    required
                    disabled={ActiveButtom}
                  />
                ) : (
                  <>
                    <FormLabel htmlFor="nationality" required>
                      Nacionalidad
                    </FormLabel>
                    <OutlinedInput
                      id="nationality"
                      autoComplete="nationality"
                      value={nationality}
                      required
                      size="small"
                      disabled={
                        nationality !== "~" || ActiveButtom ? true : sfalse
                      }
                    />
                  </>
                )}
              </FormGrid>
            </Box>

            <Box sx={{ display: "flex", gap: 2 }}>
              <FormControl error={birthplaceError} variant="outlined" fullWidth>
                <FormLabel htmlFor="birthplace" required>
                  Lugar de nacimiento
                </FormLabel>
                <OutlinedInput
                  id="birthplace"
                  autoComplete="birthplace"
                  required
                  size="small"
                  value={birthplace !== "~" ? birthplace : Birthplace}
                  onChange={BirthplaceHandleChange}
                  disabled={birthplace !== "~" || ActiveButtom ? true : sfalse}
                />
                {birthplaceError && (
                  <FormHelperText>{birthplaceErrorMessage}</FormHelperText>
                )}
              </FormControl>
            </Box>

            <Box sx={{ display: "flex", gap: 2 }}>
              <FormGrid sx={{ width: "50%", flexGrow: 1 }}>
                {countrybirth === "~" ? (
                  <AutocompleteCom
                    FormLabel={"País donde nació"}
                    error={countrybirthError}
                    errorMessage={countrybirthErrorMessage}
                    size="small"
                    placeholder={"selecciona tu pais"}
                    id={"countrybirth"}
                    setDataId={setCountryBirthID}
                    autoComplete="countrybirth"
                    options={optCountry}
                    label={""}
                    required
                    disabled={ActiveButtom}
                  />
                ) : (
                  <>
                    <FormLabel htmlFor="countrybirth" required>
                      País donde nació
                    </FormLabel>
                    <OutlinedInput
                      id="countrybirth"
                      autoComplete="countrybirth"
                      value={countrybirth}
                      required
                      size="small"
                      disabled={
                        countrybirth !== "~" || ActiveButtom ? true : sfalse
                      }
                    />
                  </>
                )}
              </FormGrid>
              <FormGrid sx={{ width: "50%", flexGrow: 1 }}>
                {gender === "~" ? (
                  <AutocompleteCom
                    FormLabel={"Género"}
                    error={genderError}
                    errorMessage={genderErrorMessage}
                    size="small"
                    placeholder={"selecciona tu genero"}
                    id={"gender"}
                    autoComplete="gender"
                    options={optGender}
                    setDataId={setGenderId}
                    label={""}
                    required
                    disabled={ActiveButtom}
                  />
                ) : (
                  <>
                    <FormLabel htmlFor="gender" required>
                      Género
                    </FormLabel>
                    <OutlinedInput
                      id="gender"
                      autoComplete="gender"
                      value={gender}
                      required
                      size="small"
                      disabled={gender !== "~" || ActiveButtom ? true : sfalse}
                    />
                  </>
                )}
              </FormGrid>
            </Box>

            <Box sx={{ display: "flex", gap: 2 }}>
              <>
                <FormGrid sx={{ width: "50%", flexGrow: 1 }}>
                  {birthdate === "~" ? (
                    <FormControl
                      error={birthdateError}
                      variant="outlined"
                      fullWidth
                    >
                      <FormLabel htmlFor="birthdate" required>
                        Fecha de nacimiento
                      </FormLabel>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale={"es-mx"}
                      >
                        <DatePicker
                          id={"birthdate"}
                          name={"birthdate"}
                          mask="____/__/__"
                          openTo="year"
                          views={["year", "month", "day"]}
                          value={valuebirthdate}
                          maxDate={dayjs(fechaFormateada)}
                          onChange={(newValue) => {
                            setValue(newValue);
                          }}
                          disabled={ActiveButtom}
                          slotProps={{
                            textField: {
                              id: "birthdate",
                              name: "birthdate",
                              error: birthdateError,
                              value: valuebirthdate,
                            },
                          }}
                        />
                        {birthdateError && (
                          <FormHelperText>
                            {birthdateErrorMessage}
                          </FormHelperText>
                        )}
                      </LocalizationProvider>
                    </FormControl>
                  ) : (
                    <>
                      <FormLabel htmlFor="birthdate" required>
                        Fecha de nacimiento
                      </FormLabel>
                      <OutlinedInput
                        sx={{ maxWidth: "85%" }}
                        id="birthdate"
                        autoComplete="birthdate"
                        required
                        value={birthdate}
                        size="small"
                        disabled={
                          birthdate !== "~" || ActiveButtom ? true : sfalse
                        }
                      />
                    </>
                  )}
                </FormGrid>
              </>
              <FormGrid sx={{ width: "50%", flexGrow: 1 }}>
                {civilstate === "~" ? (
                  <AutocompleteCom
                    FormLabel={"Estado civil"}
                    error={civilstateError}
                    setDataId={setCivilState}
                    errorMessage={civilstateErrorMessage}
                    width={"100%"}
                    size="small"
                    placeholder={"Favorites"}
                    id={"civilstate"}
                    autoComplete="civilstate"
                    options={optCivilState}
                    label={""}
                    required
                    disabled={ActiveButtom}
                  />
                ) : (
                  <>
                    <FormLabel htmlFor="civilstate" required>
                      Estado civil
                    </FormLabel>
                    <OutlinedInput
                      id="civilstate"
                      autoComplete="civilstate"
                      placeholder="Ejemplo: soltero"
                      required
                      value={civilstate}
                      size="small"
                      disabled={
                        civilstate !== "~" || ActiveButtom ? true : sfalse
                      }
                    />
                  </>
                )}
              </FormGrid>
            </Box>
            <Button
              sx={{ mt: 2 }}
              disabled={ActiveButtom}
              fullWidth
              variant="contained"
              onClick={validateInputs}
            >
              Guardar
            </Button>
          </PaymentContainer>
        </Box>
      </>
    </Stack>
  );
}
